import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../../app/guards'
import { PersonRatesPage } from '../../../features/projects/rates/person-rates-page'
import { personRatesSearchSchema } from '../../../features/projects/rates/search'

/** People's hourly cost (P6): salary-sensitive, projects.rates only (as the API). */
export const Route = createFileRoute('/_app/projects/rates')({
  staticData: { crumb: 'projectRates' },
  validateSearch: personRatesSearchSchema,
  beforeLoad: ({ context }) => requirePermission(context.session, 'projects.rates'),
  component: PersonRatesPage,
})
